import * as React from 'react';
import { useCallback } from 'react';

import { useSlate, useSlateStatic } from 'slate-react';

import { UnderlineIcon } from '@coursera/cds-icons';

import Button, { TOOLBAR_BUTTON_TYPES } from 'bundles/cml/editor/components/buttons/Button';
import { isTypeDisabled } from 'bundles/cml/editor/utils/elementUtils';
import { isMarkActive, toggleMark } from 'bundles/cml/editor/utils/markUtils';
import { getToolBarShortcutKey } from 'bundles/cml/editor/utils/toolbarUtils';
import { MARKS } from 'bundles/cml/shared/constants';

import _t from 'i18n!nls/cml';

const UnderlineButton = () => {
  const editor = useSlate();
  const staticEditor = useSlateStatic();
  const disabled = isTypeDisabled(editor, MARKS.UNDERLINE);
  const active = isMarkActive(editor, MARKS.UNDERLINE);

  const handleClick = useCallback<(...args: $TSFixMe[]) => $TSFixMe>(
    () => toggleMark(staticEditor, MARKS.UNDERLINE),
    [staticEditor]
  );

  const shortcutKey = getToolBarShortcutKey('U');
  return (
    <Button
      onClick={handleClick}
      disabled={disabled}
      active={active}
      className="rc-UnderlineButton"
      title={_t('Underline #{shortcutKey}', { shortcutKey })}
      type={TOOLBAR_BUTTON_TYPES.formatting}
    >
      <UnderlineIcon size="small" />
    </Button>
  );
};

export default UnderlineButton;
